export default {
  disabledOpacity: '0.8',
  disabledTextColor: 'brandTwo80',
  disabledBackgroundColor: 'brandTwo50',
  borderRadius: 'xLarge',
};
